import * as Types from '../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DeletePermissionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type DeletePermissionMutation = { __typename?: 'Mutation', deletePermission?: { __typename?: 'DeletePermissionPayload', successful: boolean } | null };

export const DeletePermissionDocument = gql`
    mutation DeletePermission($id: ID!) {
  deletePermission(id: $id) {
    successful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePermissionGQL extends Apollo.Mutation<DeletePermissionMutation, DeletePermissionMutationVariables> {
    document = DeletePermissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }